/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Adminsubs_Managecredits2Inputs */

const zh_adminsubs_managecredits2 = /** @type {(inputs: Adminsubs_Managecredits2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`管理点数`)
};

const en_adminsubs_managecredits2 = /** @type {(inputs: Adminsubs_Managecredits2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage Credits`)
};

const es_adminsubs_managecredits2 = /** @type {(inputs: Adminsubs_Managecredits2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestionar créditos`)
};

/**
* | output |
* | --- |
* | "Manage Credits" |
*
* @param {Adminsubs_Managecredits2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const adminsubs_managecredits2 = /** @type {((inputs?: Adminsubs_Managecredits2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Adminsubs_Managecredits2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_adminsubs_managecredits2(inputs)
	if (locale === "en") return en_adminsubs_managecredits2(inputs)
	return es_adminsubs_managecredits2(inputs)
});
export { adminsubs_managecredits2 as "adminSubs_manageCredits" }